{
  "static-content-become-partner": {
    "buttons": {
      "be-partner": "Partner werden"
    },
    "text": {
      "title": "Sind Sie Inhaber eines Schönheitssalons? Bringen Sie es heute online!",
      "description": "Warten Sie nicht länger. Fordern Sie noch heute eine kostenfreie Demo an, um zu sehen, wie unsere App Ihr Salonmanagement revolutioniert. Benutzerfreundlich und individuell anpassbar - Ihr Schlüssel zu mehr Effizienz und zufriedenen Kunden. Werden Sie heute unser Partner!"
    }
  }
}
